import { BackgroundProperty, SolidColor } from "src/types/experiences/storyboardSettings/primitives";
import { ColorResult } from "react-color";
import { DEFAULT_BACKGROUND } from "../constants/storyboard";

export const colorToCss = (c?: SolidColor | null): string => {
    if (!c) return "#FFFFFF";
  
    const clamp255 = (n: number) => Math.max(0, Math.min(255, Math.round(n)));
    const toHex2 = (n: number) => clamp255(n).toString(16).padStart(2, "0");
    const a = c.a ?? 1;
  
    const hex = `#${toHex2(c.r)}${toHex2(c.g)}${toHex2(c.b)}`.toUpperCase();
    if (a >= 1) return hex;
  
    const alphaHex = toHex2(a * 255).toUpperCase();
    return `${hex}${alphaHex}`;
  };
  
  export const rgbToSolidColor = (rgb: ColorResult["rgb"]): SolidColor => ({
    type: "solid",
    r: rgb.r,
    g: rgb.g,
    b: rgb.b,
    a: rgb.a ?? 1,
  });
  
  export const withBackgroundColor = (
    background: BackgroundProperty | null | undefined,
    color: SolidColor | null | undefined,
  ): BackgroundProperty => {
    const base = (background ?? DEFAULT_BACKGROUND) as BackgroundProperty;
    return {
      ...base,
      type: "color",
      color: color ?? null,
      media: null,
    } as BackgroundProperty;
  };

  export const isAbsoluteUrl = (url: string) => {
    if (!url) return false;
    return url.startsWith("data:") ||
    url.startsWith("blob:") ||
    url.startsWith("http://") ||
    url.startsWith("https://");
  }

  // eslint-disable-next-line no-undef
  const IMAGE_CDN = (process.env.REACT_APP_IMAGE_CDN ?? "").replace(/\/+$/, "");

  export const resolveMediaUrl = (url: string | undefined | null): string => {
    if (!url) return "";
    if (isAbsoluteUrl(url)) return url;
    const path = url.startsWith("/") ? url : `/${url}`;
    return `${IMAGE_CDN}${path}`;
  };